module.exports = __webpack_public_path__ + "static/media/mountain_biking_1366.973cd5ad.webp";